import lottie from "lottie-web"
import Rellax from 'rellax'
// import Swiper from 'swiper';
import Swiper, { Autoplay } from 'swiper';

lottie.loadAnimation({
  container: <HTMLElement>document.getElementById('anime-main'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: '/wp-content/themes/galapagos2023/assets/js/json/common/pipe.json'
});

document.addEventListener("DOMContentLoaded",() => {
  const title = document.querySelectorAll('.js-accordion');
  
  for (let i = 0; i < title.length; i += 1){
    const titleEach = title[i];
    titleEach.addEventListener('click', (e) => {
      if(e.target) {
        const accordion = e.target as Element;
        const accordionParent = accordion.closest('.accordion')
        if (accordionParent) {
          accordionParent.classList.toggle('is-active');
        }
      }
      // content.classList.toggle('is-open');
    });
  }

});

new Rellax('.js-parallaxImg', {
  speed: 1.5,
  center: true,
  breakpoints:[700, 768, 1201]
})

Swiper.use([Autoplay]);

new Swiper('.swiper', {
  autoplay: { delay: 0 },
  loop: true,
  speed: 6000,
  slidesPerView: 1.5,
  centeredSlides: true,
  preventInteractionOnTransition: true,
  breakpoints: {
    700: {
      slidesPerView: 3.3,
    }
  }
});